const components = {
    MuiStepConnector: {
        styleOverrides: {
            root: {
                '&.Mui-disabled': {
                    '.MuiStepConnector-line': {
                        border: '3px solid #E2EAF5',
                        borderRadius: '4px',
                    },
                },
                '&.Mui-active': {
                    '.MuiStepConnector-line': {
                        border: '3px solid',
                        borderRadius: '4px',
                    },
                },
                '&.Mui-completed': {
                    '.MuiStepConnector-line': {
                        border: '3px solid',
                        borderRadius: '4px',
                    },
                },
            },
        },
    },
    MuiStepLabel: {
        styleOverrides: {
            label: {
                fontFamily: 'Archivo, sans-serif', // Change the font for MuiStepLabel
                fontWeight: '700'
            },
            root: {
                '&.Mui-disabled': {
                    '.MuiSvgIcon-root': {
                        color: '#E2EAF5',

                        '.MuiStepIcon-text': {
                            color: '#fff',
                        }
                    }
                },
            }
        }
    },
    MuiStepIcon: {
        styleOverrides: {
            root: {
                width: 30, // Set the width of the circle
                height: 30, // Set the height of the circle
            },
            // text: {
            //     fill: 'white', // Change the color of the number inside the circle
            // },
        },
    },
    MuiButton: {
        styleOverrides: {
            root: {
                borderRadius: 8,
            }
        },
        variants: [
            {
                props: {variant: 'contained'},
                style: {
                    textTransform: 'none',
                    border: 'none',
                    background: '#FAC649',
                    color: '#fff',
                    padding: '12px 16px',
                    gap: '10px',
                    '&:hover': {
                        background: '#FAB42A',
                    },
                    '&:active': {
                        background: '#FBCF6F'
                    }
                },
            }, {
                props: {variant: 'outlined'},
                style: {
                    textTransform: 'none',
                    border: '2px solid #FAC649',
                    background: 'transparent',
                    color: '#FAC649',
                    padding: '12px',
                    gap: '8px',
                    '&:hover': {
                        background: '#FDF3BF',
                        border: '2px solid #FAC649',
                    },
                    '&:active': {
                        background: '#FEFAF5',
                        border: '2px solid #FAC649',
                    }
                },
            }, {
                props: {variant: 'text'},
                style: {
                    textTransform: 'none',
                    border: 'none',
                    background: 'transparent',
                    color: '#FAC649',
                    padding: '12px',
                    gap: '8px',
                    '&:hover': {
                        background: '#FAB42A',
                    },
                    '&:active': {
                        background: '#FBCF6F',
                    }
                },
            },
        ],
    },
    MuiInputBase: {
        styleOverrides: {
            root: {
                paddingLeft: 10,
                paddingRight: 10,
                paddingTop: 2,
                paddingBottom: 2,
                borderRadius: 20,
                backgroundColor: '#F3F5F7',
                transition: 'background .4s ease'
            }
        }
    },
    MuiInput: {
        styleOverrides: {
            root: {
                '&:before': {
                    content: 'none',
                },
                '&:after': {
                    content: 'none',
                },
                '&:hover': {
                    content: 'none',
                },
                '&.Mui-error': {
                    background: '#ffbaba',
                    transition: 'background .4s ease'
                },
            }
        }
    },
    MuiFormHelperText: {
        styleOverrides: {
            root: {
                // Add your font definition for helper text here
                fontFamily: 'Archivo, sans-serif',
                textTransform: 'none',
                paddingLeft: 10
                // fontSize: 14,
                // color: '#616161', // Choose your desired color
            },
        },
    },
    MuiDataGrid: {
        styleOverrides: {
            root: {
                border: '1px solid #F3F3F1',
                background: '#fff',
                borderRadius: '16px'
            },
            cell: {
                border: 'none'
            },
        }
    },
    MuiCalendarPicker: {
        styleOverrides: {
            root: {
                border: '1px solid #EFF8F3',
                borderRadius: '16px'
            },
        },
    },
    // MuiPickersDay: {
    //     styleOverrides: {
    //         root: {
    //             border: '1px solid #EFF8F3',
    //             borderRadius: '16px',
    //             "&.Mui-selected !important": {
    //                 "backgroundColor": "red"
    //             },
    //             "&.Mui-disabled": {
    //                 "backgroundColor": "red"
    //             },
    //             "not(.Mui-disabled)": {
    //                 "backgroundColor": "red"
    //             }
    //         },
    //
    //     },
    // },
}

export {components}